package features.home.ui

import kotlinx.html.*
import kotlinx.html.dom.append
import org.w3c.dom.HTMLElement
import AppState

object HomePage {
    fun render(root: HTMLElement) {
        root.innerHTML = ""
        root.append {
            div {
                // Navbar
                shared.ui.components.Navbar.render(this, "TeamMate App", showBackButton = false)
                
                // Main Content
                div("max-w-7xl mx-auto px-4 py-8 pb-32") {
                    // Dashboard Card - Shows different content based on user role
                    features.home.ui.components.DashboardCard.render(this)
                    
                    // Coming Soon Section
                    div("bg-gradient-to-br from-brand-cyan/10 to-violet-500/10 p-8 rounded-2xl border border-brand-cyan/20 text-center") {
                        img(src = "/images/dashboard/coming-soon.png", alt = "Dashboard coming soon") {
                            classes = setOf("w-96", "h-80", "mx-auto", "mb-6")
                        }
                        h2("text-2xl font-bold mb-2") { +"Dashboard Coming Soon" }
                        p("text-slate-400") {
                            +"We're working on an amazing dashboard with analytics, charts, and insights!"
                        }
                    }
                }
                
                // Bottom Navigation
                shared.ui.components.BottomNav.render(this)
            }
        }
    }
}
